import * as THREE from "three";

export const loadTargetTextues = (textureLoader) => {
  const targetColorTexture = textureLoader.load(
    "textures/target/Target_baseColor.png"
  );
  targetColorTexture.format = THREE.RGBAFormat;
  return {
    targetColorTexture,
  };
};
